import { AxiosResponse } from "axios";
import { axiosClient } from "../axiosClient";
import { axiosSafeRequest } from "../axiosSafeRequest";

type SaveMachineNamePayload = {
  machineCode: string;
  name: string;
};

type SaveMachineNameResponse = Record<string, never>;

/**
 * Saves (creates or updates) a friendly name for a machine.
 *
 * @param request The machine code and friendly name.
 * @returns An HTTP response indicating success (no body).
 */
export const apiMachineNamePost = async (
  request: SaveMachineNamePayload,
): Promise<AxiosResponse<SaveMachineNameResponse> | undefined> => {
  return axiosSafeRequest(() => axiosClient.post(`/machine/name`, request));
}
